<template>
  <div class="app-wrapper" :class="{ 'is-ipad': isIpad }">
    <Sidebar />
    <div class="main-body">
      <Navbar />
      <AppMain />
    </div>
  </div>
</template>
<script lang="ts" setup>
import AppMain from './components/AppMain.vue'
import Navbar from './components/Navbar.vue'
import Sidebar from './components/Sidebar/index.vue'
import { useDictStore } from '@/store/modules/dict'
import { usePermissionStore } from '@/store/modules/permission'
import { isEmpty } from '@/libs/utils/data-checker'
const permissionStore = usePermissionStore()
const dictStore = useDictStore()
const isIpad = window.isIpad

onBeforeMount(() => {
  dictStore.setAreaTree()
})
</script>
<style lang="scss" scoped>
.app-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: var(--defalut-bgc);
  box-sizing: border-box;
}

.main-body {
  width: calc(100% - 102px);
  flex: 1;
  height: 100%;
}

.app-wrapper.is-ipad {
  .main-body {
    width: calc(100% - 64px);
  }
}
</style>
